export const CONNECTOR_ROUTES = {
    CLAUDE: 'claude-connector',
    CHATGPT: 'chatgpt-connector',
    LOVABLE: 'lovable-connector',
} as const;

export type ConnectorRoute = (typeof CONNECTOR_ROUTES)[keyof typeof CONNECTOR_ROUTES];
